// extracted by mini-css-extract-plugin
module.exports = {"page":"DomainEnter_page_1U9j7"};